import { styled } from '@mui/material/styles';
import RadioGroup from '@mui/material/RadioGroup';
import { ModalBase } from '@components/Modal';

export const Modal = styled(ModalBase)({
    '& .modal-base-paper': {
        width: 'calc(100% - 32px)',
        height: 'calc(var(--100vh) - 32px)',
    },
    '& .modal-base-content': {
        display: 'grid',
        gridTemplateColumns: '50% 50%',
        '@media (max-width: 768px)': {
            gridTemplateColumns: '100%',
        },
    },
});

export const MainContent = styled('div')({
    padding: '24px 16px',
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'auto',
    overflowX: 'hidden',
    '@media (max-width: 768px)': {
        overflowY: 'initial',
        overflowX: 'initial',
    },
});

export const SubContent = styled('div')({
    display: 'flex',
    alignItems: 'center',
    minHeight: 300,
    justifyContent: 'center',
    backgroundColor: '#F2F2F2',
    borderTopRightRadius: 4,
    borderBottomRightRadius: 4,
    overflowY: 'auto',
    '@media (max-width: 768px)': {
        minHeight: 400,
        overflowY: 'initial',
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0,
    },
    '@media (max-width: 420px)': {
        minHeight: 300,
    },
    '& svg, img': {
        width: 384,
    },
});

export const Form = styled('div')({
    display: 'grid',
    gridGap: '8px 24px',
    gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 1fr)',
    margin: '8px 0',
    '.combo-location-multiselect': {
        gridColumn: '1 / span 2',
        '@media (max-width: 768px)': {
            gridColumn: '1',
        },
    },
    '@media (max-width: 768px)': {
        gridTemplateColumns: 'minmax(0, 1fr)',
        gridGap: '8px',
        '.react-colorful__wrapper': {
            top: '-190px !important',
            left: '0 !important',
        },
    },
    '.react-colorful__wrapper': {
        position: 'absolute',
        top: '-70px !important',
        right: '-184px !important',
        zIndex: 2,
    },
});

export const ReviewsMode = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    marginTop: 8,
});

export const ReviewsModeGroup = styled(RadioGroup)({
    flexDirection: 'column',
    '& .MuiFormControlLabel-root': {
        marginRight: 0,
        marginLeft: '-3px !important',
    },
});
